export default {
  common: {
    brand: 'USFans Spreadsheet',
    tagline: 'Independent Resource Hub',
    navHome: 'Home',
    navShoppingGuide: 'Shopping Guide',
    navGuides: 'Guides',
    navCategories: 'Categories',
    navResources: 'Resources',
    navReview: 'Review',
    navFaq: 'FAQ',
    visitMain: 'Visit Main Website',
    language: 'Language',
    mainSiteUrl: 'https://kaspreadsheet.com',
    footerAbout: 'USFans Spreadsheet is an independent resource that organizes US fan merchandise and apparel into a simple, easy-to-browse structure — so you can find what you want faster.',
    footerQuickLinks: 'Quick Links',
    footerCategories: 'Categories',
    footerDisclaimer: 'This website is an independent informational resource and is not officially affiliated with any brand unless explicitly stated. All product links lead to the main website.',
    footerRights: 'All rights reserved.',
    notFoundTitle: 'This page could not be found',
    notFoundText: 'The page you are looking for does not exist. Head back to explore the resource hub.',
  },
  cat: {
    shoes: 'Shoes',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
};